import { aiResponseMock } from "./consts";

type OrchestratorRequestBody = {
  user_prompt: {
    user_prompt_fe: string;
    user_prompt_be: string;
  };
  is_auto_gen_question: boolean;
  role_info_mode: string;
  system_language: string;
  user: string;
};

type OrchestratorResponse = {
  ok: boolean;
  text: () => Promise<string>;
};

export const sendOrchestratorRequest = async (
  requestBody: OrchestratorRequestBody,
  functionKey: string
): Promise<OrchestratorResponse> => {
  if (process.env.REACT_APP_USE_MOCKED_API === "true") {
    await new Promise((resolve) => setTimeout(resolve, 1500));
    return {
      ok: true,
      text: async () => JSON.stringify(aiResponseMock),
    };
  }
  const apiRequest = process.env.REACT_APP_MAIN_ORCHESTRATOR_URL + functionKey;
  const response = await fetch(apiRequest, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });
  return response;
};
